import { Component, inject, Injector, OnInit } from '@angular/core';
import { CompaniesService, CompanyModel, ICompanyCreateModel } from "../../../../services/companies.service";
import { CompaniesDialogBaseComponent } from '../companies-dialog-base/companies-dialog-base.component';
import { switchMap } from 'rxjs';

@Component({
    selector: 'app-create-company',
    templateUrl: '../companies-dialog-base/companies-dialog-base.component.html',
    styleUrls: ['../companies-dialog-base/companies-dialog-base.component.css'],
    standalone: false
})
export class CreateCompanyComponent extends CompaniesDialogBaseComponent<ICompanyCreateModel> implements OnInit {
    private companyService: CompaniesService = inject(CompaniesService);

    constructor(protected injector: Injector) {
        super(injector);
        this.dialogId = "createCompany";
    }

  ngOnInit() {
      super.ngOnInit();

      /*
      this.companyService.getCompanies().subscribe(companies => {
        this.companies = companies;
        if (!this.model.ParentCompanyId && this.companies.length > 0) {
          this.model.ParentCompanyId = this.companies[0].Id;
        }
      });
      */
    }

  public submit() {
      if (!this.isValid())
        return
        this.companyService.create(this.model).subscribe({
            next: (res) => {
                this.externalAPI.companyId = res.Id;
                this.companyService.saveSettings(this.externalAPI).subscribe(() => {
                    this.onCreated.emit();
                    this.close();
                    this.syncService.NotifyEntityChanged("Company", 0);
                    super.submit();
                })
            }
        });
    }
}
